var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ob1-popin-modal2",
    { attrs: { id: _vm.modalId, "aria-labelledby": _vm.modalId + "-details" } },
    [
      _vm.onlineRecovery
        ? _c("recovery-details-part", {
            attrs: { "recovery-details": _vm.onlineRecovery },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.onlineRecovery && _vm.storeRecovery
        ? _c("ob1-separateur", { staticClass: "mt-1 mb-2" })
        : _vm._e(),
      _vm._v(" "),
      _vm.storeRecovery
        ? _c("recovery-details-part", {
            attrs: { "recovery-details": _vm.storeRecovery },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }